"use strict";
/**
 * Type definitions for Batch Rate Request
 * Corresponds to RateQuality ShipmentDataToRate.cs
 */
Object.defineProperty(exports, "__esModule", { value: true });
